import React, { Component, PureComponent } from "react";
import { css, COUNTRIES, COUNTRIES_ARR, theme } from "constants";
import { Link, Modal, Text, View, AppHeader, FlatList, isWeb, TextInput, SearchBox, Scene } from "core";
import { lang } from "lang";
import { parseArabicNumber } from "utils";

const styles = css({
  item: {
    flex: 1,
    flexDirection: "row",
    height: 50,
    paddingHorizontal: 15,
    borderBottomWidth: theme.hairline,
    borderBottomColor: theme.gray_color_lighten(0.1)
  },
  native_name: {
    color: "rgba(150,150,150, 1)",
    fontSize: 12
  },
  tel_input_holder: {
    flexDirection: "row",
    alignItems: "center",
    borderColor: theme.primary_color_lighten(0.6),
    borderStyle: "solid",
    borderWidth: 1,
    borderRadius: 10
  },
  tel_input_holder_rtl: {
    flexDirection: "row-reverse"
  },
  tel_code: {
    backgroundColor: "white",
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 10,
    justifyContent: "space-around",
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    height: 48,
    width: 80
  },
  tel_code_rtl: {
    flexDirection: "row-reverse",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10
  },
  tel_number: {
    height: 48,
    width: 217,
    borderWidth: 0,
    backgroundColor: "white",
    flexDirection: "row",
    alignItems: "center",
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    marginLeft: 1,
    direction: "ltr"
  },
  tel_number_rtl: {
    flexDirection: "row",
    alignItems: "center",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    marginLeft: 0,
    marginRight: 1,
    direction: isWeb ? "ltr" : "rtl"
  }
});

const CreateFlagWeb = ({ emoji }) => {
  if (!emoji) {
    return null;
  }
  const url = window.twemoji
    .parse(emoji)
    .split('src="')[1]
    .replace('"/>', "");
  return <img src={url} alt={emoji} width={"20px"} height={"20px"} />;
};

// eslint-disable-next-line
const Flag = ({ item }) => (isWeb ? <CreateFlagWeb emoji={item.emoji} /> : <Text style={{ fontSize: 20 }}>{item.emoji}</Text>);

class TelPickerInput extends Component {
  state = { picker_off: true };
  _pickShow = () => {
    TelPicker.show(this._pickDone);
    this.setState({ picker_off: false });
  };
  _pickDone = code => {
    code && this.props.onChange({ code, phone: this.props.value.phone });
    this.setState({ picker_off: true });
  };
  render() {
    const { onChange, value, autoFocus } = this.props;
    const { picker_off } = this.state;
    const country = COUNTRIES[value.code] || {};
    return (
      <View style={[styles.tel_input_holder, lang.IS_RTL && styles.tel_input_holder_rtl]}>
        <Link content_style={[styles.tel_code, lang.IS_RTL && [styles.tel_code_rtl]]} onPress={this._pickShow}>
          <Flag item={country} />
          <Text>+</Text>
          <Text>{country.tel || ""}</Text>
        </Link>
        <TextInput
          key={`telinput_${autoFocus && picker_off}`}
          keyboardType="phone-pad"
          autoFocus={autoFocus && picker_off}
          onChangeText={phone => {
            onChange({ code: value.code, phone: parseArabicNumber(phone) });
          }}
          value={value.tel}
          style={[styles.tel_number, lang.IS_RTL && styles.tel_number_rtl]}
          placeholder={`${lang.PHONE_PH}`}
        />
      </View>
    );
  }
}

class TelItem extends PureComponent {
  render() {
    const { country, onPick } = this.props;
    return (
      <Link content_style={styles.item} onPress={() => onPick && onPick(country.code)}>
        <Flag item={country} />
        <Text style={{ marginHorizontal: 5 }}>{country.name}</Text>
        <View style={{ flex: 1 }}>{country.native ? <Text style={styles.native_name} ellipsizeMode={"tail"} numberOfLines={1}>{`(${country.native})`}</Text> : null}</View>
        <Text>{"+" + country.tel}</Text>
      </Link>
    );
  }
}
const keyExtractor = item => item.code;
const itemLayout = (data, index) => ({ length: 50, offset: 50 * index, index });

class TelPickerProvider extends Component {
  page_size = 30;
  state = { list: COUNTRIES_ARR, show_modal: false };

  componentDidMount() {
    TelPicker = this;
  }

  close = () => {
    this.onPick = null;
    this.setState({ show_modal: false });
  };

  show = onPick => {
    this.onPick = code => {
      onPick && onPick(code);
      this.close();
    };
    this.setState({ list: COUNTRIES_ARR, show_modal: true });
  };

  _renderItem = ({ item }) => <TelItem country={item} key={item.code} onPick={this.onPick} />;
  _search = () => {};
  render() {
    const { show_modal, list } = this.state;
    return (
      <Modal style={{ maxHeight: 500 }} visible={show_modal} onRequestClose={() => this.onPick(null)}>
        <Scene avoidKeyboard>
          <AppHeader title="Dial Code" close={() => this.onPick(null)} />
          <SearchBox source={COUNTRIES_ARR} keys={["name", "native", "tel", "code"]} onChange={list => this.setState({ list })} />
          <FlatList data={list} keyboardShouldPersistTaps="handled" renderItem={this._renderItem} keyExtractor={keyExtractor} getItemLayout={itemLayout} />
        </Scene>
      </Modal>
    );
  }
}
let TelPicker = {};

export { TelPickerProvider, TelPicker, TelPickerInput };



// WEBPACK FOOTER //
// ./src/components/core/tel_picker.js